import { stepIndexMap } from '../utils';

const STEP_LABELS = [
  'Initiate',
  'Notify & Respond',
  'Plan',
  'Approve',
  'Implement',
  'Review',
  'Closed',
] as const;

const STEP_ICONS = [
  'fa-flag',
  'fa-bell',
  'fa-clipboard-list',
  'fa-stamp',
  'fa-rocket',
  'fa-chart-line',
  'fa-circle-check',
] as const;

interface StepIndicatorProps {
  currentStep: string | null | undefined;
}

export default function StepIndicator({ currentStep }: StepIndicatorProps) {
  const activeIdx = currentStep ? (stepIndexMap[currentStep] ?? 0) : 0;
  const allDone   = activeIdx === -1;

  return (
    <ol className="step-indicator" aria-label="Change progress">
      {STEP_LABELS.map((label, i) => {
        const isDone   = allDone || i < activeIdx;
        const isActive = !allDone && i === activeIdx;
        const cls      = isDone ? 'is-done' : isActive ? 'is-active' : '';
        return (
          <li key={label} className={`step ${cls}`.trim()}>
            <span className="step__dot">
              <i className={`fa-solid ${STEP_ICONS[i]}`} aria-hidden="true" />
            </span>
            <span className="step__label">{label}</span>
          </li>
        );
      })}
    </ol>
  );
}
